var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveFloppy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17V12.5C5.5 11.9477 5.94771 11.5 6.5 11.5H13.5C14.0523 11.5 14.5 11.9477 14.5 12.5V17.5M14.5 3V5C14.5 5.55228 14.0523 6 13.5 6L6.5 6C5.94771 6 5.5 5.55228 5.5 5L5.5 2M17.4979 5.49789L14.5021 2.50211C14.1806 2.18062 13.7446 2 13.2899 2H3.71429C2.7675 2 2 2.7675 2 3.71429V16.2857C2 17.2325 2.7675 18 3.71429 18H16.2857C17.2325 18 18 17.2325 18 16.2857V6.71007C18 6.25542 17.8194 5.81938 17.4979 5.49789Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFloppy);
export default __webpack_public_path__ + "static/media/saveFloppy.2080da5584e862674f556d544098d30c.svg";
export { ForwardRef as ReactComponent };